import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
// Mirrors ChallengeModal.tsx's MODIFIER_KEYS (which, in turn, mirrors
// ArenaBattle::MODIFIERS on the backend) — one icon + translation key per
// selectable modifier. Kept as a hardcoded list here rather than derived
// from MODIFIER_KEYS so a future non-modifier-list use of this modal
// doesn't silently break.
const MODIFIER_ROWS = [{
  key: 'classic',
  icon: 'fas fa-star'
}, {
  key: 'tournament',
  icon: 'fas fa-trophy'
}, {
  key: 'random_cards',
  icon: 'fas fa-random'
}, {
  key: 'friendly',
  icon: 'fas fa-handshake'
}];

/** "О модификаторах" — opened from the info icon next to ChallengeModal's modifier select. */
export default class ModifierInfoModal extends Modal {
  className() {
    return 'ModifierInfoModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-question-circle"
    }), " ", app.translator.trans('forumaker-arena.forum.modifier_info.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body ModifierInfoModal-body"
    }, m("ul", {
      className: "ModifierInfoModal-list"
    }, MODIFIER_ROWS.map(_ref => {
      let {
        key,
        icon
      } = _ref;
      return m("li", {
        key: key,
        className: "ModifierInfoModal-row"
      }, m("i", {
        className: icon
      }), m("span", null, app.translator.trans(`forumaker-arena.forum.modifier_info.${key}`)));
    })), m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.modifier_info.btn')));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ModifierInfoModal', ModifierInfoModal);